import { ReactElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

// Experimental text content extractor for rendered static React. Useful for filling in metadata text fields.
// NOTE: Only usable in browser code!

export function getTextContent(element: ReactElement) {
  const html = renderToStaticMarkup(element);
  return htmlToText(html);
}

function htmlToText(html: string) {
  return new DOMParser().parseFromString(html, 'text/html').documentElement.textContent;
}
